import _ from 'lodash';
import { CREATE_EXAM, GET_EXAM, GET_ACTIVE_EXAM, GET_EXAMS, EDIT_EXAM, DELETE_EXAM } from '../actions/types';


const examReducer = (state={}, action) => {
    switch (action.type) {
        
        case GET_EXAMS:
            // console.log('GET_EXAMS', action);
            return { ...state, ..._.mapKeys(action.payload.data, 'id') };
        case GET_EXAM:
            //[action.payload.id]- key interpolation. specifies a key based on d new object we're spreading
            return { ...state, [action.payload.id]: action.payload };
        case GET_ACTIVE_EXAM:
            return { ...state, [action.payload.id]: action.payload };
        case CREATE_EXAM:
            return { ...state, [action.payload.id]: action.payload };
        case EDIT_EXAM:
            return { ...state, [action.payload.id]: action.payload };
        case DELETE_EXAM:
            //for delete action creator, our payload was d ID of d stream we deleting. omit() creates a new object of our state exclusive of object with d specified key
            return _.omit(state, action.payload);
        default:
            return state;
    }
};

export default examReducer;